






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { EventBus } from "@/pitprojekt/event-bus";
import { UserService } from "@/services/user.service"

@Component({})
export default class ChangePasswordDialog extends Vue {
  dialog: boolean  = false;
  valid: boolean  = false;
  loading: boolean = false;
  oldPassword: string = '';
  newPassword: string = '';
  newPasswordConfirm: string = '';

  newPasswordRules = [
    (v:string) => (v && v.length >= 8) || 'Minimum 8 znaków'
  ];

  get newPasswordConfirmRule() {
    return () => (this.newPassword === this.newPasswordConfirm) || 'Hasła nie są jednakowe'
  }

  created() {
    EventBus.$on('showChangePasswordDialogEvent', this.showDialog);
  }

  showDialog() {
    this.loading = false;
    this.dialog = true;
  }

  closeDialog() {
    this.dialog = false;
  }

  get formValid() {
    return (this.oldPassword !== '' && this.newPassword !== '' && this.newPasswordConfirm !== '' && this.valid);
  }

   async changePassword() {
    this.loading = true;
    let response = await UserService.changePassword(this.oldPassword, this.newPassword, this.newPasswordConfirm);
    this.loading = false;
    if (response[0] == 'OK') {
      this.oldPassword = '';
      this.newPassword = '';
      this.newPasswordConfirm = '';
      this.closeDialog();
    }
  }

}
